import React from 'react';

import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import { Stack, Tooltip } from '@mui/material';

type TResult = {
  label: string;
  to: string;
  IconComponent: (props: { fontSize?: 'small' }) => JsxNode;
};
type Props = {
  links: TResult[];
};
export default function NavigationLinksMobile({ links }: Props) {
  return (
    <Stack
      spacing={{ xs: 1, sm: 2 }}
      direction="row"
      alignItems="center"
      sx={{ flexBasis: '100%', display: { xs: 'flex', lg: 'none' } }}
    >
      {links.map(({ to, label, IconComponent }, i) => (
        <IconButtonLink key={i} href={to} sx={{ color: 'inherit' }}>
          <Tooltip title={label}>
            <IconComponent fontSize="small" />
          </Tooltip>
        </IconButtonLink>
      ))}
    </Stack>
  );
}
